import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
const plans = [
  {
    name: "Lite",
    monthly: '26/500gms',
    yearly: 990,
    des: 'A free and simplified plan best for social, small and medium e-commerce sellers',
    features: [
      { text: "Call, Email & Chat Support", available: true },
      { text: "1 Ecommerce Channnel", available: true },
      { text: "Automated Channel Order Sync", available: true },
      { text: "Limited Label Customization", available: true },
      { text: "Domestic Shipping", available: true },
    ],
  },
  {
    name: "Professional",
    monthly: '20/500gms',
    yearly: '7/KG',
    des: 'Dynamic plans for sellers who sell on multiple marketplaces and websites',
    features: [
      { text: "Shared Support Team", available: true },
      { text: "Multiple Ecommerce Channel Integrations", available: true },
      { text: "Priority Support", available: true },
      { text: "UnLimited Label Customization", available: true },
      { text: "Automated Channel Order Sync", available: true },
      { text: "Domestic Shipping", available: true }
    ],
    popular: true,
  },
  {
    name: "Enterprise",
    monthly: 'Shipping Solution',
    yearly: 2990,
    des: 'Get an exclusive plan tailored to meet your business needs',
    features: [
      { text: "Dedicated Account Manager", available: true },
      { text: "Customized Integrations", available: true },
      { text: "UnLimited Label Customization", available: true },
      { text: "Automated Channel Order Sync", available: true },
      { text: "Domestic Shipping", available: true },
    ],
  },
];

function Pricing() {
  const [yearly, setYearly] = useState(false);
  const [activeFAQ, setActiveFAQ] = useState(null);
  const filteredPlans = yearly
  ? plans.filter(plan => plan.name === "Professional")
  : plans;
  
  useEffect(() => {
    const saved = localStorage.getItem("pricingType");
    if (saved === "yearly") setYearly(true);
  }, []);

  useEffect(() => {
    localStorage.setItem("pricingType", yearly ? "yearly" : "monthly");
  }, [yearly]);

  return (
    <div className="pricing-page">
      <Helmet>
          <title>Parcelx - Prcing</title>
      </Helmet>
      <section className="section01 text-center">
        <h2 className="heading">
          Powerful features for <span>Shipping World</span>
        </h2>
        <p>Choose a plan that’s right for you</p>

        <div className="pricing-toggle">
          <span>B2C</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={yearly}
              onChange={() => setYearly(!yearly)}
            />
            <span className="slider"></span>
          </label>
          <span>
            B2B
          </span>
        </div>
      </section>

      <section className="pricing-cards">
        <div className="container-fluid">
          <div className="col-md-11 mx-auto">
            <div className="row justify-content-md-center">
              {filteredPlans.map((plan, index) => (
                <div className="col-md-4 col-sm-6 mb-3" key={index}>
                  <div className={`card ${plan.name.toLowerCase()} ${plan.popular ? "popular" : ""}`}>
                    <h3>{plan.name}</h3>
                    <p>{plan.des}</p>
                    <a href="https://seller.parcelx.in/register" className="btn btn-primary mb-2">Get Started Now</a>

                    <div className="price">
                      ₹{yearly ? plan.yearly : plan.monthly}
                      <span className="period">
                        {yearly}
                      </span>
                    </div>

                    <ul>
                      {plan.features.map((f, i) => (
                        <li key={i}>
                          <div className="icon">
                            <i className={`fal ${f.available ? "fa-check" : "fa-times"}`}></i>
                          </div>
                          <div>
                            {f.text}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricing;